import { useModal } from 'src/hooks/Modal';
import React from 'react';
import { FaCalendarCheck, FaRegCalendarPlus } from 'react-icons/fa';

type CalendarEvent = {
    title: string;
    description?: string;
    location?: string;
    startTime: string; // formato ISO
    endTime: string;   // formato ISO
};

const formatDate = (date: string) => {
    return new Date(date).toISOString().replace(/-|:|\.\d\d\d/g, '');
};

const AddToCalendarMini: React.FC<{ event: CalendarEvent }> = ({ event }) => {

    const { addModal } = useModal();

    const start = formatDate(event.startTime);
    const end = formatDate(event.endTime);

    const title = encodeURIComponent(event.title);
    const description = encodeURIComponent(event.description || '');
    const location = encodeURIComponent(event.location || '');

    const googleUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${start}/${end}&details=${description}&location=${location}`;
    const yahooUrl = `https://calendar.yahoo.com/?v=60&view=d&type=20&title=${title}&st=${start}&et=${end}&desc=${description}&in_loc=${location}`;
    const outlookUrl = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${title}&body=${description}&location=${location}&startdt=${event.startTime}&enddt=${event.endTime}&path=/calendar/action/compose`;

    const generateICS = () => {
        const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${event.title}
DESCRIPTION:${event.description || ''}
LOCATION:${event.location || ''}
DTSTART:${start}
DTEND:${end}
END:VEVENT
END:VCALENDAR`;

        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `${event.title}.ics`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const openModal = () => {

        addModal({
            title: '', key: 'modal', theme: "whiteModalMini  glass", content: <div className='column-start' style={{ gap: '16px' }}>
                <p style={{ color: '#333' }}>Adicione esta atividade à sua agenda</p>
                <button className='greenButton2' onClick={() => window.open(googleUrl, '_blank')}>Google Calendar</button>
                <button className='greenButton2' onClick={() => window.open(yahooUrl, '_blank')}>Yahoo Calendar</button>
                <button className='greenButton2' onClick={() => window.open(outlookUrl, '_blank')}>Outlook</button>
                <button className='greenButton2' onClick={generateICS}>Download .ICS</button>

            </div>
        })

    }

    return (
        <div>
            <nav className=' row' style={{ minWidth: '30px', background:'#ddd', color: '#333', maxWidth:'30px', height: '30px', padding: '0px', borderRadius:'50%' }} title='Adicionar ao calendário' onClick={() => openModal()}><FaRegCalendarPlus size={15}/></nav>

        </div>
    );
};

export default AddToCalendarMini;